import { render, staticRenderFns } from "./PartnerGroupList.vue?vue&type=template&id=13b554f4&scoped=true&"
import script from "./PartnerGroupList.vue?vue&type=script&lang=js&"
export * from "./PartnerGroupList.vue?vue&type=script&lang=js&"
import style0 from "./PartnerGroupList.vue?vue&type=style&index=0&id=13b554f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b554f4",
  null
  
)

export default component.exports